import defaults from "superagent-defaults";
const superagent = defaults();

const setDefault = () => {
  const token = localStorage.getItem("token");
  return superagent.set("Authorization", `Bearer ${token}`).set("Content-Type", "application/json");
};

export default setDefault;
